// import $ from "jquery";
// import whatInput from "what-input";
// //import flexslider from 'flexslider';
// //import Bridget from 'jquery-bridget';
// //import cookie from 'jquery.cookie';
//
// window.$ = window.jQuery = $;
// window.whatInput = whatInput;

// Get necessary imports and inits like them below. Problem with ES modules.
import $ from "./bootstrap-jquery.js";

import "foundation-sites/dist/js/foundation.js";
// console.log("FOUNDATION FILE LOADED?", typeof $.fn.foundation);
//
// console.log("ENTRY LOADED", new Date().toISOString());
// console.log("bundle $", $.fn && $.fn.jquery, "foundation:", typeof $.fn.foundation);
// console.log("window jQuery", window.jQuery && window.jQuery.fn && window.jQuery.fn.jquery,
// 	"foundation:", window.jQuery && window.jQuery.fn && typeof window.jQuery.fn.foundation);
// console.log("same instance?", window.jQuery === $);

//import Foundation from 'foundation-sites';
//console.log(Foundation);

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
// import './lib/foundation-explicit-pieces';
// import './lib/fontawesome-all';

import "flexslider";
import "jquery.cookie";

import './lib/map';

jQuery(function ($) {
	$(document).foundation();
});

(function(window, document, $, undefined) {
	"use strict";

	var win = $(window),
		doc = $(document);

	/**
	 * Center caption for slider
	 */
	function slideshowFunc() {
		var slideshow	= $('#slideshow');
		var pHeight		= slideshow.find('img').height();

		if($(window).width() > 640) {
			slideshow.find('.caption').each(function() {
				$(this).css({ 'top': (pHeight - $(this).height())/2-40 });
			});
		}
	}

	/**
	 * Vertical centering for section content
	 */
	function verticalCenter() {
		var content = $('.center-vertical');

		if(win.width() > 640) {
			content.each(function() {
				var that = $(this),
					height = that.outerHeight(),
					parent = that.parent(".row"),
					img = parent.find('img');

				if(img.height() > height) {
					that.css({'margin-top': (parent.height() - height)/2 }).show();
				} else {
					that.show();
					img.css({'margin-top': (parent.height() - img.height())/2 });
				}
			});
		} else {
			content.css({'margin-top': 'auto'}).fadeIn('fast');
		}
	}

	/**
	 * Cookie box
	 */
	/*function cookieBox() {
		if ($.cookie('medium') === undefined) {
			var container = $('#cookie-bar');

			container.addClass('cookie-not-agreed');

			$('#agree').on('click', function() {
				$.cookie('medium', 'registered', { expires: 365, path: '/' });
				container.removeClass('cookie-not-agreed');
				return false;
			});

			container.on('click', '.button', function() {
				$.cookie('medium', 'redirect');
			});
	    }
	}*/

	doc.ready(function() {
		/**
		 * Inizialize Foundation JavaScript
		 */
		//doc.foundation();

		/**
		 * Slideshow
		 */
		$('#slideshow').flexslider({
			prevText: '',
			nextText: '',
			directionNav: false,
			pauseOnAction: false,
			start: function(slider) {
				slider.css('visibility','visible').hide().fadeIn('slow');
				if($(window).width() > 640) {
					slider.find('.flex-active-slide .caption').addClass('animated fadeInUp');
				}
			},
			before: function(slider){
				if($(window).width() > 640) {
					slider.find('.caption').removeClass('animated fadeInUp');
				}
			},
			after: function(slider) {
				if($(window).width() > 640) {
					slider.find('.flex-active-slide .caption').addClass('animated fadeInUp');
				}
			}
		});

		/**
		 * News slider
		 */
		$('#news-slider').flexslider({
			pauseOnAction: false,
			start: function(slider){
				slider.css('visibility','visible').removeClass('active');
			}
		});

		/**
		 * Toggle sub menu in off canvas
		 */
		$('.expand').on('click', function() {
			$(this).next('.sub-menu').slideToggle('fast');
			var that = $(this);
	        that.toggleClass('open');
		});

		/**
		 * Toggle Searchform when icon is clicked
		 */
		$('.searchbar').click(function() {
		    $('.searchform, .searchbar').toggleClass('toggled');
		    return false;
		});

		/**
		 * Resize meny on scroll
		 */
	    var header = $('.header-2');
	    $(window).scroll(function() {
	        var scroll = $(window).scrollTop();
			if($(window).width() > 800) {
		        if (scroll >= 5) {
		            header.addClass('kulur');
		        } else {
		            header.removeClass('kulur');
		        }
			}
	    });

	});

	$(window).on('load', function(){
		slideshowFunc();
		verticalCenter();
		//cookieBox();
	});

	$(window).on('resize', function(){
		slideshowFunc();
		verticalCenter();
		//cookieBox();
	});

}(window, document, jQuery));
